import countryNamesWithCodes from './countryNameswithCode';

export const getCountryValueFromLabel = (code: string | undefined) => {
	let country = countryNamesWithCodes.find(country => country.label === code);

	return country?.value;
};
